import Carousel from "react-elastic-carousel";
import { IconButton } from "@material-ui/core";
import { NavigateBefore, NavigateNext } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
const useStyles = makeStyles((theme) => ({
   previewImage: {
      width: 200,
      margin: theme.spacing(0.5, 0),
      height: 200,
      objectFit: 'cover',
      borderRadius: 4,
      cursor: 'zoom-in',
      '&:focus': {
         outline: 0,
      }
   }
}));

const lightBoxOptions = {
   buttons: {
      showAutoplayButton: false,
      showDownloadButton: false,
      showFullscreenButton: false,
      showThumbnailsButton: false,
      size: '32px'
   },
   caption: {
      showCaption: true,
   },
   thumbnails: {
      thumbnailsOpacity: 0.4,
      thumbnailsPosition: 'bottom',
      thumbnailsSize: ['100px', '80px']
   }
}

export default function CustomImageCarousel({ defaultCaption, images, itemsToShow }) {
   const classes = useStyles();
   const navigationArrow = ({ type, onClick, isEdge }) => {
      const pointer = type === 'NEXT' ? (<NavigateNext />) : (<NavigateBefore />);
      return (<IconButton onClick={onClick} disabled={isEdge}> {pointer} </IconButton>)
   }
   if (!images || images.length === 0) {
      return null;
   }
   return (
      <div style={{ height: '220px' ,marginTop:"30px"}}>
         <SimpleReactLightbox>
            <SRLWrapper options={lightBoxOptions}>
               <Carousel itemsToShow={itemsToShow || 4} itemPosition="flex-start" showEmptySlots pagination={false} renderArrow={navigationArrow}>
                  {images.map(image => (<img alt={defaultCaption} key={image.editedUri} src={image.editedUri} className={classes.previewImage} />))}
               </Carousel>
            </SRLWrapper>
         </SimpleReactLightbox>
      </div>
   )
}